import { toString, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, option_type, list_type, int32_type, record_type, class_type, bool_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ProgressStatus__ToProperString, SearchParams, DomainEntity__get_Id, Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F, DomainEntity__get_DomainEntity, DomainEntity__get_Detail, DomainEntity__get_Name, DomainEntity_$reflection } from "../ClientTypes.fs.js";
import { ofSeq, choose as choose_1, append, length, singleton, empty, ofArray, map as map_1, filter as filter_1, truncate } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { many, entitiesCount, single } from "../Api/Entities.fs.js";
import { choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { comparePrimitives, equals, curry2, createObj, compare, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { contains, FSharpSet__get_IsEmpty, remove, add, FSharpSet__Contains, FSharpSet__get_Count, empty as empty_1, ofList } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { Cmd_batch, Cmd_OfPromise_perform, Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { EPM_Domain_Events_Maturity__Maturity_ToProperString, System_Int32__Int32_ToLocaleString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString, System_String__String_ToOption_Static_Z721C83C5 } from "../Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { map as map_2, empty as empty_2, singleton as singleton_1, append as append_1, delay as delay_1, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { useFeliz_React__React_useUnplanned_Static, useFeliz_React__React_useProgressStatus_Static, useFeliz_React__React_useMaturity_Static, useFeliz_React__React_useCriticality_Static, useFeliz_React__React_useCondition_Static, useFeliz_React__React_useStatus_Static, useFeliz_React__React_useLabels_Static_Z485ADA6F, useFeliz_React__React_useTypedParams_Static } from "../hooks/UseRouter.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { useFeliz_React__React_useDebouncer_Static } from "../hooks/UseDebouncer.fs.js";
import { tryFind, empty as empty_3, FSharpMap__Change } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { Action_Category, Maturity, Criticality, Condition, Status, DomainEntities } from "../DomainEvents.fs.js";
import { SearchParams_tagSearchParams, SearchParams_productionUnitSearchParams, SearchParams_equipmentTypeSearchParams, SearchParams_locationSearchParams, SearchParams_areaSearchParams, SearchParams_moduleSearchParams, SearchParams_disciplineSearchParams, SearchParams_facilitySearchParams, SearchParams_subsystemSearchParams, SearchParams_systemSearchParams, SearchParams_documentSearchParams, SearchParams_actionSearchParams, SearchParams_activitySearchParams } from "../Api/SearchParams.fs.js";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F } from "../hooks/UseFetch.fs.js";
import { labels as labels_2 } from "../Api/Activities.fs.js";
import { labels as labels_3 } from "../Api/Actions.fs.js";
import { labels as labels_4 } from "../Api/Documents.fs.js";
import { labels as labels_5 } from "../Api/Facilities.fs.js";
import { labels as labels_6 } from "../Api/Systems.fs.js";
import { labels as labels_7 } from "../Api/Subsystems.fs.js";
import { labels as labels_8 } from "../Api/Modules.fs.js";
import { labels as labels_9 } from "../Api/Areas.fs.js";
import { labels as labels_10 } from "../Api/Locations.fs.js";
import { labels as labels_11 } from "../Api/ProductionUnits.fs.js";
import { labels as labels_12 } from "../Api/Tags.fs.js";
import "./Filters.scss";


export class FilterLabel$1 extends Record {
    constructor(Display, Value, IsChecked, Icon) {
        super();
        this.Display = Display;
        this.Value = Value;
        this.IsChecked = IsChecked;
        this.Icon = Icon;
    }
}

export function FilterLabel$1_$reflection(gen0) {
    return record_type("EPM.App.Search.Filters.FilterLabel`1", [gen0], FilterLabel$1, () => [["Display", string_type], ["Value", gen0], ["IsChecked", bool_type], ["Icon", class_type("Fable.React.ReactElement", undefined)]]);
}

class State extends Record {
    constructor(Total, Entities, Selected, CalledApiAlready, CurrentlyShowing, Collapsed, IsFetching, IsError, Query) {
        super();
        this.Total = (Total | 0);
        this.Entities = Entities;
        this.Selected = Selected;
        this.CalledApiAlready = CalledApiAlready;
        this.CurrentlyShowing = (CurrentlyShowing | 0);
        this.Collapsed = Collapsed;
        this.IsFetching = IsFetching;
        this.IsError = IsError;
        this.Query = Query;
    }
}

function State_$reflection() {
    return record_type("EPM.App.Search.Filters.State", [], State, () => [["Total", int32_type], ["Entities", list_type(DomainEntity_$reflection())], ["Selected", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [DomainEntity_$reflection()])], ["CalledApiAlready", bool_type], ["CurrentlyShowing", int32_type], ["Collapsed", bool_type], ["IsFetching", bool_type], ["IsError", bool_type], ["Query", option_type(string_type)]]);
}

function State__get_ShouldDisplayMore(this$) {
    return this$.Total > this$.CurrentlyShowing;
}

function State__get_VisibleEntities(this$) {
    let matchValue, search, matchValue_1, s;
    return truncate(this$.CurrentlyShowing, (this$.Total <= 100) ? ((matchValue = this$.Query, (matchValue != null) ? ((search = matchValue, (matchValue_1 = search.trim().toLocaleLowerCase(), (matchValue_1 === "") ? this$.Entities : ((s = matchValue_1, filter_1((v) => {
        if (DomainEntity__get_Name(v).toLocaleLowerCase().indexOf(s) >= 0) {
            return true;
        }
        else {
            return defaultArg(map((d) => (d.toLocaleLowerCase().indexOf(s) >= 0), DomainEntity__get_Detail(v)), false);
        }
    }, this$.Entities)))))) : this$.Entities)) : this$.Entities);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadSelected", "SelectedLoaded", "CountEntities", "EntitiesCounted", "Checked", "UnChecked", "QueryChange", "ShowMore", "ToggleCollapse", "LoadFirstPage", "FirstPageLoaded", "LoadNextPage", "NextPageLoaded"];
    }
}

function Msg_$reflection() {
    return union_type("EPM.App.Search.Filters.Msg", [], Msg, () => [[["Item", list_type(class_type("System.Guid"))]], [["Item", list_type(DomainEntity_$reflection())]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", DomainEntity_$reflection()]], [["Item", DomainEntity_$reflection()]], [["Item", string_type]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(DomainEntity_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(DomainEntity_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(DomainEntity_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(DomainEntity_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]]]);
}

function loadSelected(projectId, domainEntity, ids) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        return ((pr = map_1((entityId) => single(domainEntity, projectId, entityId), ids), Promise.all(pr))).then((_arg) => {
            const selected = ofArray(choose((entityResult) => {
                if (entityResult.tag === 1) {
                    return undefined;
                }
                else {
                    return entityResult.fields[0];
                }
            }, _arg));
            return Promise.resolve(new Msg(1, [selected]));
        });
    }));
}

function count(projectId, domainEntity) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (entitiesCount(domainEntity, projectId, empty()).then((_arg) => (Promise.resolve(new Msg(3, [_arg])))))));
}

function loadFirstPage(total, projectId, domainEntity, queryOpt) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const queryParams = (queryOpt != null) ? singleton(["search", queryOpt]) : empty();
        return ((total < 250) ? many(domainEntity, projectId, empty(), queryParams) : many(domainEntity, projectId, ofArray([["fetch", int32ToString(100)], ["offset", int32ToString(0)]]), queryParams)).then((_arg) => (Promise.resolve(new Msg(10, [_arg]))));
    }));
}

function loadNextPage(entities, projectId, domainEntity, queryOpt) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const queryParams = (queryOpt != null) ? singleton(["name", queryOpt]) : empty();
        return many(domainEntity, projectId, ofArray([["fetch", int32ToString(100 + entities)], ["offset", int32ToString(entities)]]), queryParams).then((_arg) => (Promise.resolve(new Msg(12, [_arg]))));
    }));
}

function update(projectId, domainEntity, onChange, msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Total, state.Entities, ofList(msg.fields[0], {
                Compare: compare,
            }), state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, state.IsError, state.Query), Cmd_none()];
        case 2:
            return [state, Cmd_OfPromise_perform(() => count(projectId, domainEntity), undefined, (x_2) => x_2)];
        case 3: {
            const result = msg.fields[0];
            if (result.tag === 1) {
                console.error(some(result.fields[0]));
                return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, true, state.Query), Cmd_none()];
            }
            else {
                return [new State(result.fields[0], state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, state.IsError, state.Query), Cmd_none()];
            }
        }
        case 4: {
            const entity = msg.fields[0];
            onChange([entity, true]);
            return [new State(state.Total, state.Entities, ofList(singleton(entity), {
                Compare: compare,
            }), state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, state.IsError, state.Query), Cmd_none()];
        }
        case 5: {
            onChange([msg.fields[0], false]);
            return [new State(state.Total, state.Entities, empty_1({
                Compare: compare,
            }), state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, state.IsError, state.Query), Cmd_none()];
        }
        case 6:
            return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, state.IsFetching, state.IsError, System_String__String_ToOption_Static_Z721C83C5(msg.fields[0])), (state.Total > 100) ? singleton((dispatch) => {
                dispatch(new Msg(9, []));
            }) : Cmd_none()];
        case 7:
            return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing + 7, state.Collapsed, state.IsFetching, state.IsError, state.Query), ((length(state.Entities) < state.CurrentlyShowing) && (state.Total > state.CurrentlyShowing)) ? singleton((dispatch_1) => {
                dispatch_1(new Msg(11, []));
            }) : Cmd_none()];
        case 8:
            return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, !state.Collapsed, state.IsFetching, state.IsError, state.Query), state.CalledApiAlready ? Cmd_none() : singleton((dispatch_2) => {
                dispatch_2(new Msg(9, []));
            })];
        case 9:
            return [new State(state.Total, state.Entities, state.Selected, true, state.CurrentlyShowing, state.Collapsed, true, state.IsError, state.Query), Cmd_OfPromise_perform(() => loadFirstPage(state.Total, projectId, domainEntity, state.Query), undefined, (x_5) => x_5)];
        case 10: {
            const result_1 = msg.fields[0];
            if (result_1.tag === 1) {
                console.error(some(result_1.fields[0]));
                return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, false, true, state.Query), Cmd_none()];
            }
            else {
                return [new State(state.Total, result_1.fields[0], state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, false, state.IsError, state.Query), Cmd_none()];
            }
        }
        case 11:
            return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, true, state.IsError, state.Query), Cmd_OfPromise_perform(() => loadNextPage(length(state.Entities), projectId, domainEntity, state.Query), undefined, (x_6) => x_6)];
        case 12: {
            const result_2 = msg.fields[0];
            if (result_2.tag === 1) {
                console.error(some(result_2.fields[0]));
                return [new State(state.Total, state.Entities, state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, false, true, state.Query), Cmd_none()];
            }
            else {
                return [new State(state.Total, append(state.Entities, result_2.fields[0]), state.Selected, state.CalledApiAlready, state.CurrentlyShowing, state.Collapsed, false, state.IsError, state.Query), Cmd_none()];
            }
        }
        default:
            return [state, Cmd_OfPromise_perform(() => loadSelected(projectId, domainEntity, msg.fields[0]), undefined, (x) => x)];
    }
}

function init(initialSelectedEntities) {
    return [new State(0, empty(), empty_1({
        Compare: compare,
    }), false, 7, true, false, false, undefined), Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(0, [initialSelectedEntities]));
    }), singleton((dispatch_1) => {
        dispatch_1(new Msg(2, []));
    })]))];
}

function FilterOption(props) {
    let elems_3, elems_2, handler, elems_1;
    return createElement("div", createObj(ofArray([["className", "filter-option"], ["title", props.filter.Display], (elems_3 = [createElement("div", createObj(ofArray([["className", join(" ", ["pretty", "p-default", "p-smoth"])], (elems_2 = [createElement("input", createObj(ofArray([["type", "checkbox"], ["checked", props.filter.IsChecked], (handler = curry2(props.onCheckChanged)(props.filter.Value), ["onChange", (ev) => {
        handler(ev.target.checked);
    }])]))), createElement("div", createObj(ofArray([["className", "state"], (elems_1 = [createElement("label", {
        className: "filter-option-label",
        children: reactApi.Children.toArray([props.filter.Icon, props.filter.Display]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function DomainEntityFilterOption(domainEntityFilterOptionInputProps) {
    const onCheckChanged = domainEntityFilterOptionInputProps.onCheckChanged;
    const isChecked = domainEntityFilterOptionInputProps.isChecked;
    const domainEntity = domainEntityFilterOptionInputProps.domainEntity;
    return createElement("div", createObj(toList(delay_1(() => append_1(singleton_1(["className", "filter-option"]), delay_1(() => {
        let matchValue;
        return append_1((matchValue = DomainEntity__get_Detail(domainEntity), (matchValue != null) ? singleton_1(["title", matchValue]) : singleton_1(["title", EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(DomainEntity__get_DomainEntity(domainEntity))])), delay_1(() => {
            let elems_3, elems_2, elems_1, elems;
            return singleton_1((elems_3 = [createElement("div", createObj(ofArray([["className", join(" ", ["pretty", "p-default", "p-smoth"])], (elems_2 = [createElement("input", {
                type: "checkbox",
                checked: isChecked,
                onChange: (ev) => {
                    onCheckChanged([domainEntity, ev.target.checked]);
                },
            }), createElement("div", createObj(ofArray([["className", "state"], (elems_1 = [createElement("label", createObj(ofArray([["className", "is-clickable"], ["className", "filter-option-label"], (elems = toList(delay_1(() => {
                const matchValue_1 = DomainEntity__get_Detail(domainEntity);
                if (matchValue_1 != null) {
                    const detail_1 = matchValue_1;
                    return singleton_1(`${DomainEntity__get_Name(domainEntity)} : (${detail_1})`);
                }
                else {
                    return singleton_1(DomainEntity__get_Name(domainEntity));
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
        }));
    }))))));
}

function FilterOptions(props) {
    let matchValue, elems;
    const patternInput = reactApi.useState(7);
    const currentlyShowing = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState("");
    const search = patternInput_1[0];
    const hasSearchBar = length(props.values) > 10;
    const patternInput_2 = reactApi.useState(true);
    const collapsed = patternInput_2[0];
    const selectedLength = length(filter_1((f) => f.IsChecked, props.values)) | 0;
    const filterOptions = map_1((filter) => createElement(FilterOption, {
        filter: filter,
        onCheckChanged: props.onCheckChanged,
    }), (matchValue = search.trim().toLocaleLowerCase(), (matchValue === "") ? props.values : filter_1((v) => (v.Display.toLocaleLowerCase().indexOf(matchValue) >= 0), props.values)));
    const shouldDisplayMore = length(filterOptions) > currentlyShowing;
    const searchBar = hasSearchBar ? createElement("div", createObj(ofArray([["className", "filter-option-search-bar"], (elems = [createElement("input", {
        inputMode: "search",
        value: search,
        onChange: (ev) => {
            patternInput_1[1](ev.target.value);
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))) : defaultOf();
    const elms_1 = toList(delay_1(() => {
        let elems_2, elems_1;
        return append_1(singleton_1(createElement("label", createObj(Helpers_combineClasses("label", ofArray([["className", "is-clickable"], ["onClick", (_arg) => {
            patternInput_2[1](!collapsed);
        }], (elems_2 = [Fa_i(toList(delay_1(() => (collapsed ? singleton_1(new Fa_IconOption(11, ["fas fa-caret-right"])) : singleton_1(new Fa_IconOption(11, ["fas fa-caret-down"]))))), []), props.icon, props.display, createElement("span", createObj(ofArray([["className", join(" ", ["ml-1"])], (elems_1 = toList(delay_1(() => append_1((selectedLength > 0) ? append_1(singleton_1(createElement("span", {
            children: System_Int32__Int32_ToLocaleString(selectedLength),
            className: "has-text-success",
        })), delay_1(() => singleton_1(" / "))) : empty_2(), delay_1(() => singleton_1(createElement("span", {
            children: System_Int32__Int32_ToLocaleString(length(props.values)),
            className: "has-text-info",
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), delay_1(() => {
            let elms, elems_3;
            return !collapsed ? singleton_1((elms = singleton(createElement("div", createObj(ofArray([["className", "filter-option-container"], (elems_3 = toList(delay_1(() => append_1(hasSearchBar ? singleton_1(searchBar) : empty_2(), delay_1(() => append_1(truncate(currentlyShowing, filterOptions), delay_1(() => (shouldDisplayMore ? singleton_1(createElement("div", createObj(ofArray([op_PlusPlus(["className", "show-more-text"], ["className", "is-clickable"]), ["onClick", (_arg_1) => {
                patternInput[1](currentlyShowing + 7);
            }], ["children", "Show More..."]])))) : empty_2()))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("div", {
                className: "control",
                children: reactApi.Children.toArray(Array.from(elms)),
            }))) : empty_2();
        }));
    }));
    return createElement("div", {
        className: "field",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    });
}

function getExistingIds(domainEntity, searchParams) {
    return choose_1((p) => {
        let matchResult, entityId_1, entityType_1;
        if (p.tag === 2) {
            if (equals(p.fields[1], domainEntity)) {
                matchResult = 0;
                entityId_1 = p.fields[0];
                entityType_1 = p.fields[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return entityId_1;
            default:
                return undefined;
        }
    }, searchParams);
}

function changeSearchParam(param, isChecked) {
    if (isChecked) {
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(param), false);
    }
    else {
        Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC(singleton(param));
    }
}

function onCheckChange(entity, isChecked) {
    const param = new SearchParams(2, [DomainEntity__get_Id(entity), DomainEntity__get_DomainEntity(entity)]);
    if (isChecked) {
        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(param), false);
    }
    else {
        Feliz_Router_Router__Router_navigateQueryPathExclude_Static_180030EC(singleton(param));
    }
}

function EntityFilter(entityFilterInputProps) {
    let elems;
    const projectId = entityFilterInputProps.projectId;
    const domainEntity = entityFilterInputProps.domainEntity;
    const key = entityFilterInputProps.$key;
    let patternInput;
    const init_1 = init(getExistingIds(domainEntity, useFeliz_React__React_useTypedParams_Static()));
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, state) => update(projectId, domainEntity, (tupledArg) => {
        onCheckChange(tupledArg[0], tupledArg[1]);
    }, msg, state), (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useDebouncer_Static("", (arg) => {
        dispatch(new Msg(6, [arg]));
    }, 300);
    const searchBar = (state_1.Total > 10) ? createElement("div", createObj(ofArray([["className", "filter-option-search-bar"], (elems = [createElement("input", {
        inputMode: "search",
        value: patternInput_1[0],
        onChange: (ev) => {
            patternInput_1[1](ev.target.value);
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))) : defaultOf();
    const elms_1 = toList(delay_1(() => append_1(singleton_1(createElement("label", createObj(Helpers_combineClasses("label", toList(delay_1(() => append_1((state_1.Total > 0) ? singleton_1(["className", "is-clickable"]) : singleton_1(["className", join(" ", ["is-not-allowed", "no-filter"])]), delay_1(() => append_1(singleton_1(["onClick", (_arg_2) => {
        dispatch(new Msg(8, []));
    }]), delay_1(() => {
        let elems_2;
        return singleton_1((elems_2 = toList(delay_1(() => append_1((state_1.Total > 0) ? singleton_1(Fa_i(toList(delay_1(() => (state_1.Collapsed ? singleton_1(new Fa_IconOption(11, ["fas fa-caret-right"])) : singleton_1(new Fa_IconOption(11, ["fas fa-caret-down"]))))), [])) : empty_2(), delay_1(() => append_1(singleton_1(EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(domainEntity)), delay_1(() => {
            let elems_1;
            return singleton_1(createElement("span", createObj(ofArray([["className", join(" ", ["ml-1"])], (elems_1 = toList(delay_1(() => (state_1.IsFetching ? singleton_1("...") : ((state_1.Total > 0) ? append_1((FSharpSet__get_Count(state_1.Selected) > 0) ? append_1(singleton_1(createElement("span", {
                children: System_Int32__Int32_ToLocaleString(FSharpSet__get_Count(state_1.Selected)),
                className: "has-text-success",
            })), delay_1(() => singleton_1(" / "))) : empty_2(), delay_1(() => singleton_1(createElement("span", {
                children: System_Int32__Int32_ToLocaleString(state_1.Total),
                className: "has-text-info",
            })))) : empty_2())))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))]));
    })))))))))), delay_1(() => {
        let elms, elems_3;
        return !state_1.Collapsed ? singleton_1((elms = singleton(createElement("div", createObj(ofArray([["className", "filter-option-container"], (elems_3 = toList(delay_1(() => append_1(singleton_1(searchBar), delay_1(() => append_1(map_1((domainEntity_2) => createElement(DomainEntityFilterOption, {
            domainEntity: domainEntity_2,
            isChecked: FSharpSet__Contains(state_1.Selected, domainEntity_2),
            onCheckChanged: (tupledArg_1) => {
                const domainEntity_1 = tupledArg_1[0];
                if (tupledArg_1[1]) {
                    dispatch(new Msg(4, [domainEntity_1]));
                }
                else {
                    dispatch(new Msg(5, [domainEntity_1]));
                }
            },
        }), State__get_VisibleEntities(state_1)), delay_1(() => (State__get_ShouldDisplayMore(state_1) ? singleton_1(createElement("div", createObj(toList(delay_1(() => append_1(singleton_1(op_PlusPlus(["className", "show-more-text"], ["className", "is-clickable"])), delay_1(() => append_1(singleton_1(["onClick", (_arg_3) => {
            dispatch(new Msg(7, []));
        }]), delay_1(() => (state_1.IsFetching ? singleton_1(["children", "Fetching..."]) : singleton_1(["children", "Show More..."]))))))))))) : empty_2()))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))) : empty_2();
    }))));
    return createElement("div", {
        className: "field",
        children: reactApi.Children.toArray(Array.from(elms_1)),
    });
}

function onCheckChangeLabel(existingLabels, domainEntity, labelKey, labelValue, isChecked) {
    Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(5, [domainEntity, FSharpMap__Change(existingLabels, labelKey, (v) => {
        const set$ = defaultArg(v, empty_1({
            Compare: comparePrimitives,
        }));
        if (isChecked) {
            return add(labelValue, set$);
        }
        else {
            const newSet = remove(labelValue, set$);
            return FSharpSet__get_IsEmpty(newSet) ? undefined : newSet;
        }
    })])), false);
}

function mapPageResult(successMap, resultPromise) {
    return resultPromise.then((result) => Result_Map((list) => map_1(successMap, list), result));
}

function ActivityLabelFilter(activityLabelFilterInputProps) {
    const projectId = activityLabelFilterInputProps.projectId;
    const categoryOpt = activityLabelFilterInputProps.categoryOpt;
    let patternInput;
    const initial = empty_3({
        Compare: comparePrimitives,
    });
    patternInput = reactApi.useState(initial);
    let patternInput_1;
    const initial_1 = empty_3({
        Compare: comparePrimitives,
    });
    patternInput_1 = reactApi.useState(initial_1);
    const existingActivityLabels = useFeliz_React__React_useLabels_Static_Z485ADA6F(new DomainEntities(5, []));
    const existingActionLabels = useFeliz_React__React_useLabels_Static_Z485ADA6F(new DomainEntities(11, []));
    const filters_1 = useFeliz_React__React_useTypedParams_Static();
    const patternInput_2 = reactApi.useState(undefined);
    const activityFilters = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const actionFilters = patternInput_3[0];
    const dependencies = [filters_1, map(toString, categoryOpt)];
    reactApi.useEffect(() => {
        const newActivityFilters = SearchParams_activitySearchParams(categoryOpt, filters_1);
        const newActionFilters = SearchParams_actionSearchParams(categoryOpt, filters_1);
        if (!equals(newActivityFilters, activityFilters)) {
            patternInput_2[1](newActivityFilters);
        }
        if (!equals(newActionFilters, actionFilters)) {
            patternInput_3[1](newActionFilters);
        }
    }, dependencies);
    const activityLabelsFetch = useFeliz_React__React_useOptionalFetch_Static_5B82200F((activityParams) => labels_2(projectId, activityParams), activityFilters, [projectId, map(toString, categoryOpt), activityFilters]);
    const dependencies_2 = [activityLabelsFetch];
    reactApi.useEffect(() => {
        if (activityLabelsFetch.tag === 2) {
            patternInput[1](activityLabelsFetch.fields[0]);
        }
    }, dependencies_2);
    const actionLabelsFetch = useFeliz_React__React_useOptionalFetch_Static_5B82200F((actionParams) => labels_3(projectId, actionParams), actionFilters, [projectId, map(toString, categoryOpt), actionFilters]);
    const dependencies_4 = [actionLabelsFetch];
    reactApi.useEffect(() => {
        if (actionLabelsFetch.tag === 2) {
            patternInput_1[1](actionLabelsFetch.fields[0]);
        }
    }, dependencies_4);
    const filterActivityOptions = map_2((label) => {
        const filters_2 = ofSeq(map_2((value) => (new FilterLabel$1(value, value, defaultArg(map((v) => contains(value, v), tryFind(label[0], existingActivityLabels)), false), Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tag"])), []))), label[1]));
        return createElement(FilterOptions, {
            display: label[0],
            icon: Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tags"])), []),
            onCheckChanged: (labelValue, isChecked) => {
                onCheckChangeLabel(existingActivityLabels, new DomainEntities(5, []), label[0], labelValue, isChecked);
            },
            values: filters_2,
        });
    }, patternInput[0]);
    const filterActionOptions = map_2((label_1) => {
        const filters_3 = ofSeq(map_2((value_2) => (new FilterLabel$1(value_2, value_2, defaultArg(map((v_1) => contains(value_2, v_1), tryFind(label_1[0], existingActionLabels)), false), Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tag"])), []))), label_1[1]));
        return createElement(FilterOptions, {
            display: "Action -" + label_1[0],
            icon: Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tags"])), []),
            onCheckChanged: (labelValue_1, isChecked_1) => {
                onCheckChangeLabel(existingActionLabels, new DomainEntities(11, []), label_1[0], labelValue_1, isChecked_1);
            },
            values: filters_3,
        });
    }, patternInput_1[0]);
    const xs = toList(delay_1(() => append_1(filterActivityOptions, delay_1(() => filterActionOptions))));
    return react.createElement(react.Fragment, {}, ...xs);
}

function LabelFilter(labelFilterInputProps) {
    const projectId = labelFilterInputProps.projectId;
    const domainEntity = labelFilterInputProps.domainEntity;
    let patternInput;
    const initial = empty_3({
        Compare: comparePrimitives,
    });
    patternInput = reactApi.useState(initial);
    const existingLabels = useFeliz_React__React_useLabels_Static_Z485ADA6F(domainEntity);
    const filters_1 = useFeliz_React__React_useTypedParams_Static();
    const patternInput_1 = reactApi.useState(undefined);
    const labelFilters = patternInput_1[0];
    const dependencies = [domainEntity, filters_1];
    reactApi.useEffect(() => {
        let newFilters;
        switch (domainEntity.tag) {
            case 9: {
                newFilters = SearchParams_documentSearchParams(filters_1);
                break;
            }
            case 1: {
                newFilters = SearchParams_systemSearchParams(filters_1);
                break;
            }
            case 2: {
                newFilters = SearchParams_subsystemSearchParams(filters_1);
                break;
            }
            case 3: {
                newFilters = SearchParams_facilitySearchParams(filters_1);
                break;
            }
            case 4: {
                newFilters = SearchParams_disciplineSearchParams(filters_1);
                break;
            }
            case 5: {
                newFilters = SearchParams_activitySearchParams(undefined, filters_1);
                break;
            }
            case 6: {
                newFilters = SearchParams_moduleSearchParams(filters_1);
                break;
            }
            case 7: {
                newFilters = SearchParams_areaSearchParams(filters_1);
                break;
            }
            case 8: {
                newFilters = SearchParams_locationSearchParams(filters_1);
                break;
            }
            case 10: {
                newFilters = SearchParams_equipmentTypeSearchParams(filters_1);
                break;
            }
            case 11: {
                newFilters = SearchParams_actionSearchParams(undefined, filters_1);
                break;
            }
            case 13: {
                newFilters = SearchParams_productionUnitSearchParams(filters_1);
                break;
            }
            case 12:
            case 14: {
                console.warn(some(`Trying to call filters for ${domainEntity}`));
                newFilters = empty();
                break;
            }
            default:
                newFilters = SearchParams_tagSearchParams(filters_1);
        }
        if (!equals(newFilters, labelFilters)) {
            patternInput_1[1](newFilters);
        }
    }, dependencies);
    const labelsFetch = useFeliz_React__React_useOptionalFetch_Static_5B82200F((domainEntity.tag === 9) ? ((documentParams) => labels_4(projectId, documentParams)) : ((domainEntity.tag === 3) ? ((facilityParams) => labels_5(projectId, facilityParams)) : ((domainEntity.tag === 1) ? ((systemParams) => labels_6(projectId, systemParams)) : ((domainEntity.tag === 2) ? ((subsystemParams) => labels_7(projectId, subsystemParams)) : ((domainEntity.tag === 5) ? ((activityParams) => labels_2(projectId, activityParams)) : ((domainEntity.tag === 6) ? ((moduleParams) => labels_8(projectId, moduleParams)) : ((domainEntity.tag === 7) ? ((areaParams) => labels_9(projectId, areaParams)) : ((domainEntity.tag === 8) ? ((locationParams) => labels_10(projectId, locationParams)) : ((domainEntity.tag === 11) ? ((actionParams) => labels_3(projectId, actionParams)) : ((domainEntity.tag === 13) ? ((productionUnitTypeParams) => labels_11(projectId, productionUnitTypeParams)) : ((domainEntity.tag === 14) ? ((console.warn(some(`Trying to call filters for ${domainEntity}`)), (_arg) => {
        const a = new FSharpResult$2(0, [empty_3({
            Compare: comparePrimitives,
        })]);
        return Promise.resolve(a);
    })) : ((domainEntity.tag === 10) ? ((console.warn(some(`Trying to call filters for ${domainEntity}`)), (_arg) => {
        const a = new FSharpResult$2(0, [empty_3({
            Compare: comparePrimitives,
        })]);
        return Promise.resolve(a);
    })) : ((domainEntity.tag === 12) ? ((console.warn(some(`Trying to call filters for ${domainEntity}`)), (_arg) => {
        const a = new FSharpResult$2(0, [empty_3({
            Compare: comparePrimitives,
        })]);
        return Promise.resolve(a);
    })) : ((domainEntity.tag === 4) ? ((console.warn(some(`Trying to call filters for ${domainEntity}`)), (_arg) => {
        const a = new FSharpResult$2(0, [empty_3({
            Compare: comparePrimitives,
        })]);
        return Promise.resolve(a);
    })) : ((tagParams) => labels_12(projectId, tagParams))))))))))))))), labelFilters, [projectId, toString(domainEntity), labelFilters]);
    const dependencies_2 = [labelsFetch];
    reactApi.useEffect(() => {
        if (labelsFetch.tag === 2) {
            patternInput[1](labelsFetch.fields[0]);
        }
    }, dependencies_2);
    const filterOptions = map_2((label) => {
        const filters_2 = ofSeq(map_2((value) => (new FilterLabel$1(value, value, defaultArg(map((v) => contains(value, v), tryFind(label[0], existingLabels)), false), Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tag"])), []))), label[1]));
        return createElement(FilterOptions, {
            display: label[0],
            icon: Fa_i(singleton(new Fa_IconOption(11, ["fas fa-tags"])), []),
            onCheckChanged: (labelValue, isChecked) => {
                onCheckChangeLabel(existingLabels, domainEntity, label[0], labelValue, isChecked);
            },
            values: filters_2,
        });
    }, patternInput[0]);
    return react.createElement(react.Fragment, {}, ...filterOptions);
}

function StatusFilter() {
    const existingStatus = useFeliz_React__React_useStatus_Static();
    const filters_1 = map_1((status) => (new FilterLabel$1(toString(status), new SearchParams(6, [status]), equals(existingStatus, status), defaultOf())), ofArray([new Status(5, []), new Status(0, []), new Status(3, []), new Status(2, []), new Status(1, []), new Status(4, [])]));
    return createElement(FilterOptions, {
        display: "Status",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

function ConditionFilter() {
    const existingCondition = useFeliz_React__React_useCondition_Static();
    const filters_1 = map_1((condition) => (new FilterLabel$1(toString(condition), new SearchParams(7, [condition]), equals(existingCondition, condition), defaultOf())), ofArray([new Condition(0, []), new Condition(1, []), new Condition(2, []), new Condition(3, []), new Condition(4, [])]));
    return createElement(FilterOptions, {
        display: "Condition",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

function CriticalityFilter() {
    const existingCondition = useFeliz_React__React_useCriticality_Static();
    const filters_1 = map_1((criticality) => (new FilterLabel$1(toString(criticality), new SearchParams(8, [criticality]), equals(existingCondition, criticality), defaultOf())), ofArray([new Criticality(0, []), new Criticality(4, []), new Criticality(2, []), new Criticality(1, []), new Criticality(3, [])]));
    return createElement(FilterOptions, {
        display: "Criticality",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

function MaturityFilter() {
    const existingMaturity = useFeliz_React__React_useMaturity_Static();
    const filters_1 = map_1((maturity) => (new FilterLabel$1(EPM_Domain_Events_Maturity__Maturity_ToProperString(maturity), new SearchParams(9, [maturity]), equals(existingMaturity, maturity), defaultOf())), ofArray([new Maturity(5, []), new Maturity(3, []), new Maturity(4, []), new Maturity(6, []), new Maturity(2, []), new Maturity(1, []), new Maturity(0, [])]));
    return createElement(FilterOptions, {
        display: "Maturity",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

function ProgressFilter() {
    const existingStatus = useFeliz_React__React_useProgressStatus_Static();
    const filters_1 = map_1((status) => (new FilterLabel$1(ProgressStatus__ToProperString(status), new SearchParams(10, [status]), equals(existingStatus, status), defaultOf())), ofArray(["completed", "behind", "toDo", "overHours"]));
    return createElement(FilterOptions, {
        display: "Progress",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

function UnplanedFilter() {
    const existingStatus = useFeliz_React__React_useUnplanned_Static();
    const filters_1 = ofArray([new FilterLabel$1("Planned", new SearchParams(11, [false]), equals(existingStatus, false), defaultOf()), new FilterLabel$1("Unplanned", new SearchParams(11, [true]), equals(existingStatus, true), defaultOf())]);
    return createElement(FilterOptions, {
        display: "Planned",
        icon: defaultOf(),
        onCheckChanged: (param, isChecked) => {
            changeSearchParam(param, isChecked);
        },
        values: filters_1,
    });
}

export function filters(projectId, entityType) {
    let xs_1, $key2986ACE8, xs_2, $keyZ281BECAC, $key293FCE86, xs_3, $key31DC0E69, $key54EBC3E6, $keyZ66CCCB8A, xs_4, $key4C74B432, $key4AAF5DFE, xs_5, $key2A4D8815, $keyZ621232B5, $keyZ2ED2060, $key6E635349, $keyZ501D9D6, $keyZ4A0BC358, $key1AEECF33, $key4FD639A5, $key29310A79, xs_6, xs_7, $key1DDC16BF, $key6C4CB1E4, $key446819A7, $keyZ4DCD2BB5, $keyZ3D948EC0, $keyZ450122E0, $key4F83B787, $keyZ3EC0DC81, $keyZ108725E4, $key2F00AB4A, $key42633575, xs_8, $keyZ118BFB40, $key6F15C62B, $key7F806589, $keyZ3E6BC803, $keyZ42C4A440, $keyZ1086CC5C, $key248D01C8, $key5EB0865B, $key61E83633, $key5DE94FF1, $key36A0A188, xs_9, $keyZF4F7BB5, $keyZ120C99EC, $key44B4D36D, $keyZ50B00D95, $keyZ58E7062B, $key4F688C73, $key7C71CC13, $key77782B33, $key1C3A4516, $keyZ618F4307, $key866D4F2, xs_10, $key171C5771, $keyZ465805D8, $key68463C78, $key7D500C29, $keyZ6F4D49B6, $keyZ75CFC55D, $key44363AF7, $keyZ125141BA, $key4A860180, $key40B834DA, $key60789C21, xs_11, $keyZ6F1A13C1, $key6C0E1129, $keyZ5D3CAF2F, $keyZ7855DFE3, $keyZ5E01E637, $keyZ6C2D515, $keyZ464059EE, $key41FE371D, $key50721B2F, $keyZ1AC3DDF6, xs_12, $key3820D990, $keyZ62F7179C, $keyZ20359E2F, $key774ED111, $key57BAA10F, $key51ABFE04, $key7236796, $key28119421, $key7EE0BE7F, $key340719D7, $key6EADEB98, xs_13, $keyZ246CDBDB, $keyZ2D03977, $key2BE618A9, $key13FE1FEA, $key6C8B33E2, $keyZ58FD21D6, $key65212F5, $keyZ39724DE1, $key614960EF, $key4CB97692, $keyZ4E484499, xs_14, $keyZ35D1325A, $key4C23ADE1, $keyZ6B62AA7E, $key7CD8BB69, $keyZE6FF20D, $keyZ234918BE, $keyZ5ED0D35E, $key48E9C17C, $keyZ36666EF2, $key34009E19, $keyZE108DAD, xs, $key3E3F089A;
    switch (entityType) {
        case "facility":
            return createElement(LabelFilter, {
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            });
        case "module":
            return (xs_1 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            }), ($key2986ACE8 = (`${"module"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key2986ACE8,
                $key: $key2986ACE8,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_1));
        case "area":
            return (xs_2 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            }), ($keyZ281BECAC = (`${"area"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $keyZ281BECAC,
                $key: $keyZ281BECAC,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key293FCE86 = (`${"area"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key293FCE86,
                $key: $key293FCE86,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_2));
        case "location":
            return (xs_3 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            }), ($key31DC0E69 = (`${"location"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key31DC0E69,
                $key: $key31DC0E69,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key54EBC3E6 = (`${"location"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key54EBC3E6,
                $key: $key54EBC3E6,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ66CCCB8A = (`${"location"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ66CCCB8A,
                $key: $keyZ66CCCB8A,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_3));
        case "productionUnit":
            return createElement(LabelFilter, {
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            });
        case "subsystem":
            return (xs_4 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            }), ($key4C74B432 = (`${"subsystem"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key4C74B432,
                $key: $key4C74B432,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($key4AAF5DFE = (`${"subsystem"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $key4AAF5DFE,
                $key: $key4AAF5DFE,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_4));
        case "tag":
            return (xs_5 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(0, []),
                projectId: projectId,
            }), ($key2A4D8815 = (`${"tag"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key2A4D8815,
                $key: $key2A4D8815,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($keyZ621232B5 = (`${"tag"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $keyZ621232B5,
                $key: $keyZ621232B5,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ2ED2060 = (`${"tag"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ2ED2060,
                $key: $keyZ2ED2060,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($key6E635349 = (`${"tag"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $key6E635349,
                $key: $key6E635349,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($keyZ501D9D6 = (`${"tag"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $keyZ501D9D6,
                $key: $keyZ501D9D6,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($keyZ4A0BC358 = (`${"tag"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $keyZ4A0BC358,
                $key: $keyZ4A0BC358,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key1AEECF33 = (`${"tag"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key1AEECF33,
                $key: $key1AEECF33,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key4FD639A5 = (`${"tag"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key4FD639A5,
                $key: $key4FD639A5,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key29310A79 = (`${"tag"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key29310A79,
                $key: $key29310A79,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            })), createElement(CriticalityFilter, null), createElement(StatusFilter, null), createElement(ConditionFilter, null)], react.createElement(react.Fragment, {}, ...xs_5));
        case "document":
            return (xs_6 = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(9, []),
                projectId: projectId,
            })], react.createElement(react.Fragment, {}, ...xs_6));
        case "scopeOfWork":
            return (xs_7 = [createElement(ActivityLabelFilter, {
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($key1DDC16BF = (`${"scopeOfWork"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $key1DDC16BF,
                $key: $key1DDC16BF,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($key6C4CB1E4 = (`${"scopeOfWork"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $key6C4CB1E4,
                $key: $key6C4CB1E4,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key446819A7 = (`${"scopeOfWork"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key446819A7,
                $key: $key446819A7,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($keyZ4DCD2BB5 = (`${"scopeOfWork"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $keyZ4DCD2BB5,
                $key: $keyZ4DCD2BB5,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ3D948EC0 = (`${"scopeOfWork"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ3D948EC0,
                $key: $keyZ3D948EC0,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ450122E0 = (`${"scopeOfWork"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ450122E0,
                $key: $keyZ450122E0,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key4F83B787 = (`${"scopeOfWork"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key4F83B787,
                $key: $key4F83B787,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($keyZ3EC0DC81 = (`${"scopeOfWork"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $keyZ3EC0DC81,
                $key: $keyZ3EC0DC81,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($keyZ108725E4 = (`${"scopeOfWork"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $keyZ108725E4,
                $key: $keyZ108725E4,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key2F00AB4A = (`${"scopeOfWork"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key2F00AB4A,
                $key: $key2F00AB4A,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key42633575 = (`${"scopeOfWork"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key42633575,
                $key: $key42633575,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_7));
        case "nonConformanceReport":
            return (xs_8 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(6, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($keyZ118BFB40 = (`${"scopeOfWork"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $keyZ118BFB40,
                $key: $keyZ118BFB40,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($key6F15C62B = (`${"scopeOfWork"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $key6F15C62B,
                $key: $key6F15C62B,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key7F806589 = (`${"scopeOfWork"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key7F806589,
                $key: $key7F806589,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($keyZ3E6BC803 = (`${"scopeOfWork"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $keyZ3E6BC803,
                $key: $keyZ3E6BC803,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ42C4A440 = (`${"scopeOfWork"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ42C4A440,
                $key: $keyZ42C4A440,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ1086CC5C = (`${"scopeOfWork"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ1086CC5C,
                $key: $keyZ1086CC5C,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key248D01C8 = (`${"scopeOfWork"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key248D01C8,
                $key: $key248D01C8,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($key5EB0865B = (`${"scopeOfWork"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $key5EB0865B,
                $key: $key5EB0865B,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key61E83633 = (`${"scopeOfWork"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key61E83633,
                $key: $key61E83633,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key5DE94FF1 = (`${"scopeOfWork"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key5DE94FF1,
                $key: $key5DE94FF1,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key36A0A188 = (`${"scopeOfWork"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key36A0A188,
                $key: $key36A0A188,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_8));
        case "activity":
            return (xs_9 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(0, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($keyZF4F7BB5 = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $keyZF4F7BB5,
                $key: $keyZF4F7BB5,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($keyZ120C99EC = (`${"activity"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $keyZ120C99EC,
                $key: $keyZ120C99EC,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key44B4D36D = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key44B4D36D,
                $key: $key44B4D36D,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($keyZ50B00D95 = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $keyZ50B00D95,
                $key: $keyZ50B00D95,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ58E7062B = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ58E7062B,
                $key: $keyZ58E7062B,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($key4F688C73 = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $key4F688C73,
                $key: $key4F688C73,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key7C71CC13 = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key7C71CC13,
                $key: $key7C71CC13,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($key77782B33 = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $key77782B33,
                $key: $key77782B33,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key1C3A4516 = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key1C3A4516,
                $key: $key1C3A4516,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($keyZ618F4307 = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $keyZ618F4307,
                $key: $keyZ618F4307,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key866D4F2 = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key866D4F2,
                $key: $key866D4F2,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_9));
        case "certification":
            return (xs_10 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(1, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($key171C5771 = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $key171C5771,
                $key: $key171C5771,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($keyZ465805D8 = (`${"activity"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $keyZ465805D8,
                $key: $keyZ465805D8,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key68463C78 = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key68463C78,
                $key: $key68463C78,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key7D500C29 = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key7D500C29,
                $key: $key7D500C29,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ6F4D49B6 = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ6F4D49B6,
                $key: $keyZ6F4D49B6,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ75CFC55D = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ75CFC55D,
                $key: $keyZ75CFC55D,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key44363AF7 = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key44363AF7,
                $key: $key44363AF7,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($keyZ125141BA = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $keyZ125141BA,
                $key: $keyZ125141BA,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key4A860180 = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key4A860180,
                $key: $key4A860180,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key40B834DA = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key40B834DA,
                $key: $key40B834DA,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key60789C21 = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key60789C21,
                $key: $key60789C21,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_10));
        case "punchList":
            return (xs_11 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(2, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($keyZ6F1A13C1 = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $keyZ6F1A13C1,
                $key: $keyZ6F1A13C1,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key6C0E1129 = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key6C0E1129,
                $key: $key6C0E1129,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($keyZ5D3CAF2F = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $keyZ5D3CAF2F,
                $key: $keyZ5D3CAF2F,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZ7855DFE3 = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZ7855DFE3,
                $key: $keyZ7855DFE3,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ5E01E637 = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ5E01E637,
                $key: $keyZ5E01E637,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($keyZ6C2D515 = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $keyZ6C2D515,
                $key: $keyZ6C2D515,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($keyZ464059EE = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $keyZ464059EE,
                $key: $keyZ464059EE,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key41FE371D = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key41FE371D,
                $key: $key41FE371D,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key50721B2F = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key50721B2F,
                $key: $key50721B2F,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($keyZ1AC3DDF6 = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $keyZ1AC3DDF6,
                $key: $keyZ1AC3DDF6,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_11));
        case "documentTracking":
            return (xs_12 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(3, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($key3820D990 = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $key3820D990,
                $key: $key3820D990,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($keyZ62F7179C = (`${"activity"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $keyZ62F7179C,
                $key: $keyZ62F7179C,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($keyZ20359E2F = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $keyZ20359E2F,
                $key: $keyZ20359E2F,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key774ED111 = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key774ED111,
                $key: $key774ED111,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($key57BAA10F = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $key57BAA10F,
                $key: $key57BAA10F,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($key51ABFE04 = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $key51ABFE04,
                $key: $key51ABFE04,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key7236796 = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key7236796,
                $key: $key7236796,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($key28119421 = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $key28119421,
                $key: $key28119421,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key7EE0BE7F = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key7EE0BE7F,
                $key: $key7EE0BE7F,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key340719D7 = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key340719D7,
                $key: $key340719D7,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($key6EADEB98 = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $key6EADEB98,
                $key: $key6EADEB98,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_12));
        case "preservation":
            return (xs_13 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(4, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($keyZ246CDBDB = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $keyZ246CDBDB,
                $key: $keyZ246CDBDB,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($keyZ2D03977 = (`${"activity"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $keyZ2D03977,
                $key: $keyZ2D03977,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($key2BE618A9 = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $key2BE618A9,
                $key: $key2BE618A9,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key13FE1FEA = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key13FE1FEA,
                $key: $key13FE1FEA,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($key6C8B33E2 = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $key6C8B33E2,
                $key: $key6C8B33E2,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ58FD21D6 = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ58FD21D6,
                $key: $keyZ58FD21D6,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($key65212F5 = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key65212F5,
                $key: $key65212F5,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($keyZ39724DE1 = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $keyZ39724DE1,
                $key: $keyZ39724DE1,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($key614960EF = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $key614960EF,
                $key: $key614960EF,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key4CB97692 = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key4CB97692,
                $key: $key4CB97692,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($keyZ4E484499 = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $keyZ4E484499,
                $key: $keyZ4E484499,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_13));
        case "technicalQuery":
            return (xs_14 = [createElement(ActivityLabelFilter, {
                categoryOpt: new Action_Category(5, []),
                projectId: projectId,
            }), createElement(ProgressFilter, null), createElement(UnplanedFilter, null), ($keyZ35D1325A = (`${"activity"}:${new DomainEntities(12, [])}`), createElement(EntityFilter, {
                key: $keyZ35D1325A,
                $key: $keyZ35D1325A,
                domainEntity: new DomainEntities(12, []),
                projectId: projectId,
            })), ($key4C23ADE1 = (`${"activity"}:${new DomainEntities(11, [])}`), createElement(EntityFilter, {
                key: $key4C23ADE1,
                $key: $key4C23ADE1,
                domainEntity: new DomainEntities(11, []),
                projectId: projectId,
            })), createElement(MaturityFilter, null), ($keyZ6B62AA7E = (`${"activity"}:${new DomainEntities(3, [])}`), createElement(EntityFilter, {
                key: $keyZ6B62AA7E,
                $key: $keyZ6B62AA7E,
                domainEntity: new DomainEntities(3, []),
                projectId: projectId,
            })), ($key7CD8BB69 = (`${"activity"}:${new DomainEntities(6, [])}`), createElement(EntityFilter, {
                key: $key7CD8BB69,
                $key: $key7CD8BB69,
                domainEntity: new DomainEntities(6, []),
                projectId: projectId,
            })), ($keyZE6FF20D = (`${"activity"}:${new DomainEntities(7, [])}`), createElement(EntityFilter, {
                key: $keyZE6FF20D,
                $key: $keyZE6FF20D,
                domainEntity: new DomainEntities(7, []),
                projectId: projectId,
            })), ($keyZ234918BE = (`${"activity"}:${new DomainEntities(8, [])}`), createElement(EntityFilter, {
                key: $keyZ234918BE,
                $key: $keyZ234918BE,
                domainEntity: new DomainEntities(8, []),
                projectId: projectId,
            })), ($keyZ5ED0D35E = (`${"activity"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $keyZ5ED0D35E,
                $key: $keyZ5ED0D35E,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            })), ($key48E9C17C = (`${"activity"}:${new DomainEntities(1, [])}`), createElement(EntityFilter, {
                key: $key48E9C17C,
                $key: $key48E9C17C,
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            })), ($keyZ36666EF2 = (`${"activity"}:${new DomainEntities(2, [])}`), createElement(EntityFilter, {
                key: $keyZ36666EF2,
                $key: $keyZ36666EF2,
                domainEntity: new DomainEntities(2, []),
                projectId: projectId,
            })), ($key34009E19 = (`${"activity"}:${new DomainEntities(4, [])}`), createElement(EntityFilter, {
                key: $key34009E19,
                $key: $key34009E19,
                domainEntity: new DomainEntities(4, []),
                projectId: projectId,
            })), ($keyZE108DAD = (`${"activity"}:${new DomainEntities(10, [])}`), createElement(EntityFilter, {
                key: $keyZE108DAD,
                $key: $keyZE108DAD,
                domainEntity: new DomainEntities(10, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs_14));
        default:
            return (xs = [createElement(LabelFilter, {
                domainEntity: new DomainEntities(1, []),
                projectId: projectId,
            }), ($key3E3F089A = (`${"system"}:${new DomainEntities(13, [])}`), createElement(EntityFilter, {
                key: $key3E3F089A,
                $key: $key3E3F089A,
                domainEntity: new DomainEntities(13, []),
                projectId: projectId,
            }))], react.createElement(react.Fragment, {}, ...xs));
    }
}

